import * as React from "react";
import {
	doSessionLogging,
	QnACardClicked,
	ComponentViewLog,
	recommendationLoaded,
	logRecommendationAvailability,
} from "../Helper/logging";
import Card, { CardType } from "./Card";
import QnACard, { QnARecommendation } from "./QnACard";
import RecommendationService from "../Helper/RecommendationService";
import { RecommendationKind } from "../App";
import { RecommendationList } from "./Recommendation";
import { RecommendationSet } from "./Slider";
import { params } from "../context";

export interface CardsProps {
	groupName: string;
	groupId: number;
	initialState?: CardState;
}

export interface CardState {
	set?: RecommendationSet;
}

const redirectHomePage = async (
	e: React.MouseEvent<HTMLDivElement, MouseEvent>
) => {
	if (typeof window === "undefined") {
		return;
	}
	await doSessionLogging({ qna_ns_rec_qna_more_click: params.questionId });
	window.localStorage.setItem("qna_cshp_autoscroll", "1");
};

class Cards extends React.Component<CardsProps, CardState> {
	static displayName = "Cards";
	recommendationRef: React.RefObject<HTMLDivElement>;
	componentViewLog: typeof ComponentViewLog;

	constructor(props: CardsProps) {
		super(props);
		this.recommendationRef = React.createRef();
		this.state = { ...this.props.initialState };
		this.componentViewLog = Object.create(ComponentViewLog);
	}

	getRecommendationRef() {
		return this.recommendationRef.current;
	}

	render() {
		const { props, state } = this;

		if (!state.set || !state.set.items || state.set.items.length === 0) {
			return null;
		}

		return (
			<div ref={this.recommendationRef} className="csrec-qna csrec-cards">
				<div
					data-test="qna-page-recommendation-heading"
					className="csrec-heading"
				>
					Up next for you in {props.groupName}
				</div>
				<div className="csrec-cards-viewport">
					<div className="csrec-main">
						{state.set.items
							.slice(0, 2)
							.map((item: QnARecommendation, index) => {
								return (
									<QnACard
										key={item.questionId}
										{...item}
										click={cardData => this.handleQnACardClick(cardData)}
										cardNumber={index + 1}
									/>
								);
							})}
						<Card cardClickHandler={e => redirectHomePage(e)}>
							<a
								data-test="qna-page-recommendation-see-more"
								className="csrec-link"
								href="/study"
								target="_blank"
							>
								<span>See more questions for subjects you study</span>
							</a>
						</Card>
					</div>
				</div>
			</div>
		);
	}

	componentDidUpdate() {
		if (this.componentViewLog.componentViewLoggingDone) {
			this.viewLogging();
		}
		if (
			this.state.set &&
			this.state.set.items &&
			this.state.set.items.length > 0
		) {
			logRecommendationAvailability(RecommendationKind.QnA, "qna");
		}
	}

	async componentDidMount() {
		if (!this.state.set && this.props.groupId && this.props.groupName) {
			let recommendationList: RecommendationList;
			try {
				recommendationList = await RecommendationService.fetchRecommendations({
					kind: RecommendationKind.QnA,
					selected: this.props.groupId.toString(),
					limit: "2",
				});

				this.setState({
					set: recommendationList.set,
				});
			} catch (e) {
				console.error(e);
				return;
			}
		}
		this.componentViewLog.init(this.getRecommendationRef(), () => {
			this.viewLogging();
		});
	}

	viewLogging() {
		if (this.state.set) {
			recommendationLoaded(
				{
					kind: RecommendationKind.QnA,
					recommendationId: this.state.set.id,
					groupid: this.props.groupId,
					itemsCount: Math.min(this.state.set.items.length, 2),
				},
				"qna"
			);
		}
	}

	async handleQnACardClick(cardData: CardType) {
		window.open(cardData.link, "_blank");
		const hasVideo = !!cardData.thumbnailURL;
		await QnACardClicked(cardData, this.state.set.id);
		if (typeof window !== "undefined" && hasVideo) {
			window.localStorage.setItem(`qna_video_card_clicked`, "1");
		}
	}
}

export default Cards;
